import { comingNext } from "@/mocks/melonData";

export default function ComingNext() {
  return (
    <section id="coming" className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-700">
            <i className="ri-more-2-fill" /> 未完待续
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">下回分解 · 预告</h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            还在发酵中的瓜，先埋个悬念。随时回来，看它们的下一步走向。
          </p>
        </div>
        <a
          href="#subscribe"
          className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg bg-accent-500 text-background-50 hover:bg-accent-600 px-5 py-2.5 text-sm font-semibold transition-colors"
        >
          <i className="ri-bell-line" />
          订阅追更提醒
        </a>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {comingNext.map((c) => (
          <article
            key={c.id}
            className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 hover:border-accent-300 transition-colors"
          >
            <div className="relative overflow-hidden">
              <img
                src={c.img}
                alt={`${c.target}事件下回分解预告图`}
                className="aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/92 px-3 py-1 text-[11px] font-semibold text-foreground-700">
                <i className="ri-time-line text-accent-600" />
                {c.eta}
              </span>
            </div>
            <div className="p-5">
              <span className="text-xs font-medium text-accent-700">{c.target}</span>
              <h3 className="mt-2 text-base font-bold leading-snug text-foreground-950 group-hover:text-accent-800 transition-colors">
                {c.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{c.digest}</p>
              <p className="mt-4 flex items-start gap-2 rounded-lg bg-secondary-100/70 px-3 py-2.5 text-xs text-secondary-800">
                <i className="ri-lightbulb-flash-line mt-0.5 shrink-0" />
                <span>
                  线索提示：<strong className="font-semibold">{c.clue}</strong>
                </span>
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}